import emailIcon from "../assets/email_icon.png";
import githubIcon from "../assets/github_icon.png";
import linkedinIcon from "../assets/linkedin_icon.png";
import twitterIcon from "../assets/twitter_icon.png";

const SOCIAL_PROFILES = [
  {
    id: 1,
    link: "anatulea14@gmail.com",
    image: emailIcon,
  },
  {
    id: 2,
    link: "https://github.com/anatulea",
    image: githubIcon,
  },
  {
    id: 3,
    link: "https://www.linkedin.com/in/anatulea",
    image: linkedinIcon,
  },
  {
    id: 4,
    link: "https://twitter.com/tulea_ana",
    image: twitterIcon,
  },
];

export default SOCIAL_PROFILES;
